module.exports = __webpack_public_path__ + "img/icon_sad.e29da25.svg";